import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import GenericPromises from "../../../../api/GenericPromises";
import { useEffect, useState } from "react";
import { SalesInvoiceRelationshipType } from "../../../../interfaces/Sales/Catalogs/salesInvoiceRelationshipTypes";
import { Menuitem } from "../../../../interfaces/Security/menu";
import { usePermissions } from "../../../../hooks/usePermissions";
import useSnackBar from "../../../../components/Commons/SnackBar/useSnackBar";
import { Spinner } from "../../../../components/Commons/Spinner/Spinner";
import { ButtonStyled } from "../../../../theme/buttons";
import { Button } from "@mui/material";
import { Header } from "../../../../components/Header";
import { GenericDialog } from "../../../../components/Dialogs/Dialog";
import { UpdateSalesInvoiceRelationshipTypes } from "./update";


export const ViewSalesInvoiceRelationshipTypes = () => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const { GenericGetResource, GenericDeleteResource } = GenericPromises();
  const [salesInvoiceRelationshipTypeLocal, setSalesInvoiceRelationshipTypeLocal] = useState<SalesInvoiceRelationshipType>();
  const [openDialog, setOpenDialog] = useState(false);
  const [dataloaded, setDataLoaded] = useState(false);
  const [resourceScreen, setResourceScreen] = useState<Menuitem>();
  const { GetResourceByUrl } = usePermissions();
  const { showSnackBar, SnackbarComponent } = useSnackBar();

  const onDelete = () => {
    GenericDeleteResource(`/salesinvoicerelationshiptypes/${salesInvoiceRelationshipTypeLocal?.sales_invoice_relationship_type_id}`)
      .then(() => {
        setOpenDialog(false);
        navigate("/salesinvoicerelationshiptypes", { state: { method: "delete" }, replace: true });
      })
      .catch((error) => {
        showSnackBar(error.message, 'error');
        setOpenDialog(false);
      })
  }

  useEffect(() => {
    if (location.state === null) return navigate("/salesinvoicerelationshiptypes", { state: {}, replace: true });
    GenericGetResource(`/salesinvoicerelationshiptypes/${location.state.row.sales_invoice_relationship_type_id}`)
      .then(
        (response) => {
          setSalesInvoiceRelationshipTypeLocal(response.data);

          GetResourceByUrl(`/salesinvoicerelationshiptypes`)
            .then((response1) => {
              setResourceScreen((prev) => response1);
              setDataLoaded(true);
            })
            .catch((error) => {
              showSnackBar(error.message, 'error');
            });
        }
      ).catch((error) => {
        showSnackBar(error.message, 'error');
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {!dataloaded && <Spinner />}
      {dataloaded &&
        <>
          <Header
            title={t("salesinvoicerelationshiptypes.title-view")}
            child={
              <div className='d-flex flex-row-reverse m-1'>
                {resourceScreen?.delete === true &&
                  <ButtonStyled variant="contained" className="my-1" onClick={() => setOpenDialog(true)}>{t("generic.buttons.delete")}</ButtonStyled>
                }
                <Button variant="outlined" onClick={() => { navigate("/salesinvoicerelationshiptypes", { replace: true }) }}>{t("generic.buttons.goback")}</Button>
              </div>
            }
          />
          {resourceScreen?.read &&
            <>
              <div>
                <UpdateSalesInvoiceRelationshipTypes salesinvoiceRelationshipTypesPayload={salesInvoiceRelationshipTypeLocal} isEdit={resourceScreen?.update} />
              </div>
            </>
          }
        </>
      }
      <GenericDialog
        title={t("generic.dialog.delete")}
        content={t("salesinvoicerelationshiptypes.dialog.delete")}
        open={openDialog}
        setOpen={setOpenDialog}
        onAcept={onDelete}
      />
      <SnackbarComponent />
    </>
  )
}
